export const capitalize = (value?: string) => {
  if (!value) return '';

  return `${value[0].toUpperCase()}${value.substr(1, value.length).toLowerCase()}`;
};

export default capitalize;
